import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import Button from 'jbc-front/components/Button';
import Balloon from 'src/components/Balloon';
import { isJobSuccess } from 'src/reducers/JobStatus';
import DownloadCsvModalContainer from '../containers/DownloadCsvModalContainer';
import styles from './DownloadCsv.scss';
import { useTranslation } from 'react-i18next';

const DownloadCsv = props => {
  const { isCreating } = props;
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const isInitialFetched = useRef(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!isInitialFetched.current) {
      if (!_.isEmpty(props.downloadEmployeeCsvJobInfo) && !isJobSuccess(props.downloadEmployeeCsvJobInfo.status)) {
        props.fetchDownloadEmployeeCsvJobStatus();
      }
      isInitialFetched.current = true;
    }
  });

  return (
    <div className={styles.employeesDownload}>
      {isCreating && (
        <Balloon className={styles.employeesDownloadBalloon}>
          {t('features.Employees.components.DownloadCsv.This_process_takes_some_time_File_will_be_sent_to_your_email_after_completed')}
        </Balloon>
      )}
      <Button radius onClick={() => setIsDownloadModalOpen(true)} disabled={isCreating}>
        {t('features.Employees.components.DownloadCsv.download_employee_data')}
      </Button>
      <DownloadCsvModalContainer isOpen={isDownloadModalOpen} hideModal={() => setIsDownloadModalOpen(false)} />
    </div>
  );
};

export default DownloadCsv;
